/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingLineItemSummaryRequest extends models.BillingSummaryBase {
    getFixupPrototypeFunction() { return BillingLineItemSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingLineItemSummaryRequest>): BillingLineItemSummaryRequest {
        let obj = Object.assign(new BillingLineItemSummaryRequest(), model);
        BillingLineItemSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingLineItemSummaryRequest>): BillingLineItemSummaryRequest {
        if (!model) return null;
        return BillingLineItemSummaryRequest.newInstance(<BillingLineItemSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingLineItemSummaryRequest) {
        if (!obj) return;

        models.BillingLineItemSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingLineItemSummaryRequest): boolean {
        if (models.BillingSummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingLineItemSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.key) {
            models.BillingGroupByDetails.fixupPrototype(this.key);
        }
    }

    /**
     * Field to return results for
     */
    key: models.BillingGroupByDetails;

}
